export enum ContactUsTypes {

    SUBMIT_CONTACT_US = "SUBMIT_CONTACT_US",
    CONTACT_US_SUBMITTED = "CONTACT_US_SUBMITTED",
    GET_FEEDBACK_TYPES = "GET_FEEDBACK_TYPES",
    SET_FEEDBACK_TYPES = "SET_FEEDBACK_TYPES",
}